import * as requestFromServer from "./eventsCrud";
import { eventsSlice, callTypes } from "./eventsSlice";
import * as auth from "../../../Auth/_redux/authRedux";

const { actions } = eventsSlice;

export const fetchEvents = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findEvents(queryParams)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { totalCount, entities } = response.data;
      dispatch(actions.eventsFetched({ totalCount, entities }));
    })
    .catch(error => {
      error.clientMessage = "Can't find Events";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchEvent = id => dispatch => {
  if (!id) {
    return dispatch(actions.eventFetched({ eventForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEventById(id)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const event = response.data.event;
      dispatch(actions.eventFetched({ eventForEdit: event }));
    })
    .catch(error => {
      error.clientMessage = "Can't find event";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchEventAttendance = id => dispatch => {
  if (!id) {
    return dispatch(actions.eventAttendanceFetched({ eventAttendance: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEventAttendanceById(id)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const eventAttendance = response.data.eventAttendance;
      const totalAttendance = response.data.totalAttendance;
      dispatch(actions.eventAttendanceFetched({ eventAttendance: eventAttendance, totalAttendance: totalAttendance }));
    })
    .catch(error => {
      error.clientMessage = "Can't find event attendance";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createEventAttendance = eventAttendance => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .addEventAttendance(eventAttendance)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { eventAttendance, totalAttendace } = response.data;
      dispatch(actions.eventAttendanceCreated({ eventAttendance, totalAttendace }));
    })
    .catch(error => {
      error.clientMessage = "Can't create event attendance";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

//bulkAddEventAttendance
export const bulkAddEventAttendance = eventAttendance => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .bulkAddEventAttendance(eventAttendance)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { eventAttendance, totalAttendace } = response.data;
      dispatch(actions.eventAttendanceCreated({ eventAttendance, totalAttendace }));
    })
    .catch(error => {
      error.clientMessage = "Can't create event attendance";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

////fetchAttendanceReport
export const fetchAttendanceReport = (queryParams) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAttendanceReport(queryParams)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { attendanceReport } = response.data;
      dispatch(actions.attendanceReportFetched({ attendanceReport }));
    })
    .catch(error => {
      error.clientMessage = "Can't find attendance report";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const updateEventAttendance = eventAttendance => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEventAttendance(eventAttendance)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventAttendanceUpdated({ eventAttendance }));
    })
    .catch(error => {
      error.clientMessage = "Can't update event attendance";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const removeEventAttendance = eventAttendance => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .removeEventAttendance(eventAttendance)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventAttendanceDeleted({ id: eventAttendance.id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete event attendance";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

//fetchProfessionals
export const fetchProfessionals = search => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .fetchProfessionals(search)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { professionals } = response.data;
      dispatch(actions.professionalsFetched({ professionals }));
    })
    .catch(error => {
      error.clientMessage = "Can't find professionals";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const deleteEvent = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEvent(id)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete event";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createEvent = eventForCreation => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createEvent(eventForCreation)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      const { event } = response.data;
      dispatch(actions.eventCreated({ event }));
    })
    .catch(error => {
      error.clientMessage = "Can't create event";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEvent = event => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEvent(event)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventUpdated({ event }));
    })
    .catch(error => {
      error.clientMessage = "Can't update event";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEventsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForEvents(ids, status)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventsStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update events status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteEvents = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEvents(ids)
    .then(response => {
      if (response.data.result_code === 2 || response.data.result_code === 7) dispatch(auth.actions.logout());
      dispatch(actions.eventsDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete Events";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};